import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M29.2102 60.0909L21 31H26.6676L31.909 52.3778H32.179L37.7756 31H42.9319L48.5427 52.392H48.7983L54.0397 31H59.7074L51.4972 60.0909H46.2983L40.4744 39.679H40.2472L34.409 60.0909H29.2102Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default IconLogo;
